import { fetchAuthSession } from '@aws-amplify/auth'
import { env } from '@/lib/env'

export class ApiError extends Error {
  constructor(
    public status: number,
    public statusText: string,
    public body: unknown,
  ) {
    super(`API error ${String(status)}: ${statusText}`)
    this.name = 'ApiError'
  }
}

async function getAccessToken(): Promise<string> {
  const session = await fetchAuthSession()
  const token = session.tokens?.accessToken.toString()
  if (!token) throw new Error('No access token available')
  return token
}

export async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = await getAccessToken()
  const url = `${env.VITE_BFF_API_URL}${path}`

  const mergedHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  }
  if (options.headers) {
    const extra = new Headers(options.headers)
    for (const [key, value] of extra.entries()) {
      mergedHeaders[key] = value
    }
  }

  const response = await fetch(url, {
    ...options,
    headers: mergedHeaders,
  })

  if (!response.ok) {
    if (response.status === 401) {
      // Session expired — redirect to sign-in
      globalThis.location.href = '/sign-in'
    }
    const body: unknown = await response.json().catch(() => null)
    throw new ApiError(response.status, response.statusText, body)
  }

  return response.json() as Promise<T>
}
